var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"placeholder",style:(_vm.styles)},[_vm._t("default",function(){return [_c('h1',{staticClass:"is-size-2 is-uppercase",staticStyle:{"color":"rgba(0, 0, 0, 0.0875)"}},[_vm._v(_vm._s(_vm.label))])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }